import { createAsyncAction } from 'typesafe-actions';
import ActionTypes from './actionTypes';
import { Dashboard } from '../../../models/dashboard';

export const getStatusReportAsync = createAsyncAction(
    ActionTypes.STATUS_REPORT_REQUEST,
    ActionTypes.STATUS_REPORT_SUCCESS,
    ActionTypes.STATUS_REPORT_FAILED,
)<void, Dashboard, unknown>();
